import { useCallback, useEffect, useState } from "react";
import { MdClose } from "react-icons/md";

import { getListArea } from "../../../API/Lists/area";

export function AreasPill({ data, areaList, handleChange, areaType }) {
  console.log("data ", data);
  //   const selectedItems = areaList.filter((item) => data.includes(item.id));
  const isSelected = (item) => {
    return typeof data[0] === "string" ? data.includes(item.value) : data.includes(item.id);
  };
  const selectedItems = areaList.filter(isSelected);
  const [selecteds, setSelecteds] = useState([...selectedItems]);

  useEffect(() => {
    handleChange({
      target: {
        name: "areas",
        value: selecteds.map((item) => item.id),
      },
    });
  }, [selecteds]);

  const handleClick = (item) => {
    if (!selecteds.includes(item)) {
      setSelecteds([...selecteds, item]);
    }
  };

  const handleClickRemove = (item) => {
    const array = selecteds.filter((selected) => selected.id !== item.id);
    setSelecteds(array);
  };

  return (
    <div className="d-block">
      <div className="d-flex gap-2 flex-wrap mb-2">
        {selecteds.map((item) => (
          <div className={"p-1 ps-3 rounded-pill d-flex justify-content-between align-items-center gap-2"} style={{ backgroundColor: "white", color: "black" }}>
            {item.value}
            <div
              role="button"
              onClick={() => handleClickRemove(item)}
              className={`d-flex justify-content-center align-items-center rounded-circle me-1 `}
              style={{ width: 20, height: 20, backgroundColor: "#E1E1E1", color: "#717171" }}
            >
              <MdClose />
            </div>
          </div>
        ))}
      </div>
      <div className="input-underline mb-3" />
      <div className="d-flex gap-2 flex-wrap">
        {areaList.map((item) => (
          <div
            role="button"
            onClick={() => handleClick(item)}
            className={`p-1 px-3 rounded-pill ${selecteds.includes(item) ? "opacity-50" : ""}`}
            style={{ backgroundColor: "#38285c", color: "white" }}
          >
            {item.value}
          </div>
        ))}
      </div>
    </div>
  );
}
